import { render, staticRenderFns } from "./CourseDetailsIndividual.vue?vue&type=template&id=79859ed7&scoped=true&"
import script from "./CourseDetailsIndividual.vue?vue&type=script&lang=js&"
export * from "./CourseDetailsIndividual.vue?vue&type=script&lang=js&"
import style0 from "./CourseDetailsIndividual.vue?vue&type=style&index=0&id=79859ed7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79859ed7",
  null
  
)

export default component.exports